import React from "react";
import {
  IconDatabaseOff,
  IconExclamationMark,
  IconInfoCircle,
  IconSearchOff,
} from "@tabler/icons-react";
import { useTranslation } from "react-i18next";
import Button from "components/Button";
import UploadEPDModal from "../EPDSearch/UploadEPDModal";

const EmptyView = (props: {
  errorCode?: number;
  message?: string;
  button?: React.ReactNode;
}) => {
  const { t } = useTranslation();
  const [openEPDModal, setOpenEPDModal] = React.useState(false);

  const onOpenUploadEPDModal = () => {
    setOpenEPDModal(true);
  };

  return (
    <div className="flex flex-col items-center justify-center h-full p-6">
      {props.errorCode ? (
        <IconDatabaseOff className="h-[76px] w-[76px] mb-5 text-gray-200" />
      ) : (
        <IconSearchOff className="!h-14 !w-14 mb-5 text-gray-200" />
      )}
      <div className="text-gray-500 text-xs mb-8">
        {props.errorCode ? props.message : t("productEditor.noEPDFound")}
      </div>
      {props.errorCode ? (
        <div className="flex items-center justify-center text-red-700">
          <IconExclamationMark
            className="w-6 h-6 mr-2 text-red-600 bg-red-100 rounded-full p-1"
            stroke={3}
          />
          <div className="text-xs font-medium">
            {`${t("productEditor.errorCode")}: ${props.errorCode}`}
          </div>
        </div>
      ) : (
        <div className="flex items-center justify-center text-indigo-600">
          <IconInfoCircle
            className="!h-6 !w-6 p-1 mr-2 bg-indigo-100 rounded-full"
            stroke={3}
          />
          <div className="text-xs font-medium">
            {t("productEditor.missingEPD")}
          </div>
        </div>
      )}
      {props.errorCode ? null : (
        <>
          <Button
            width="fit-content"
            className="mt-8"
            onClick={onOpenUploadEPDModal}
          >
            {t("productEditor.requestIndividualEPD")}
          </Button>
          <UploadEPDModal
            open={openEPDModal}
            close={() => setOpenEPDModal(false)}
          />
        </>
      )}
      {props.button}
    </div>
  );
};

export default EmptyView;
